<template>
  <v-flex text-center>
    <v-flex text-right pr-5 pt-2>
      <v-btn
        icon @click="$router.push('/service')"
        >
        <v-icon white--text> add </v-icon>
      </v-btn>
    </v-flex>
    <v-layout row>
      <v-flex xs12 sm8 offset-sm2>
        <ServicesList v-on:reload="reloadServices()" :services="services" :products="products"/>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import axios from 'axios'
import ServicesList from './ServicesList.vue'
import { urlDev, urlProd } from '../settings/settings.json'

const apiUrl = process.env.NODE_ENV === 'production' ? urlProd : urlDev

axios.defaults.baseURL = apiUrl
var instance = axios.create({
  headers: { 'Authorization': 'Bearer ' + localStorage.token }
}); export default {
  components: { ServicesList },
  data () {
    return {
      services: [],
      products: [],
      errors: []
    }
  },
  methods: {
    reloadServices () {
      instance.get('/' + this.$session.get('brand') + '/services')
        .then(response => {
          this.services = response.data.data
          instance.get('/' + this.$session.get('brand') + '/products')
            .then(response => {
              this.products = response.data.data[0].products
            })
            .catch(() => this.$router.push('/error'))
        })
        .catch(() => { this.$router.push('/error') })
    }
  },
  created () {
    instance.get('/' + this.$session.get('brand') + '/services')
      .then(response => {
        this.services = response.data.data
      })
      .catch(() => this.$router.push('/error'))
    instance.get('/' + this.$session.get('brand') + '/products')
      .then(response => {
        this.products = response.data.data[0].products
      })
      .catch(() => this.$router.push('/error'))
  }
}
</script>

<style>

</style>
